// Timezone-safe date formatting helpers.
//
// Business dates (contract start/end, accrual periods, payout due dates) are
// stored in the backend as midnight UTC. Rendering them via `new Date(...)`
// uses the browser's LOCAL time, which (depending on TZ + whether the ISO
// string carries a "+00:00" suffix) can shift the displayed day backwards by
// one day. These helpers parse the YYYY-MM-DD prefix directly from the ISO
// string so the displayed date matches the date that was entered, regardless
// of the browser timezone or whether the backend serialized the value as
// tz-aware (Postgres) or tz-naive (SQLite) datetime.

const MONTHS_DE_SHORT = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

const parseYmd = (input) => {
  if (!input) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(input));
  if (!m) return null;
  return { y: parseInt(m[1], 10), mo: parseInt(m[2], 10), d: parseInt(m[3], 10) };
};

export const formatDateUtc = (dateString) => {
  const p = parseYmd(dateString);
  if (!p) return '-';
  return `${String(p.d).padStart(2, '0')}.${String(p.mo).padStart(2, '0')}.${p.y}`;
};

export const formatMonthYearUtc = (dateString) => {
  const p = parseYmd(dateString);
  if (!p) return '-';
  return `${MONTHS_DE_SHORT[p.mo - 1]} ${p.y}`;
};

// For full timestamps (real moments in time, e.g. message created_at).
// Keep local-time rendering since these reflect when something happened.
export const formatDateTimeLocal = (dateString) => {
  if (!dateString) return '-';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '-';
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${day}.${month}.${year} ${hh}:${mm}`;
};
